import classNames from 'classnames';
import Image from 'next/image';

import { Button } from '@/ui/index';
import { ArrowRight } from '@/icons/index';

import styles from './InternetBlock.module.scss';

const InternetBlock = ({ contentData, nonDesktop }) => (
  <div
    className={classNames([
      styles.wrapper,
      { [styles.nonDesktop]: nonDesktop },
    ])}
    itemScope
    itemType='http://schema.org/Service'
  >
    <div className={styles.internetBlock}>
      <div className={styles.internetInfo}>
        <div>
          {contentData?.title && (
            <div className={styles.internetTitle}>{contentData?.title}</div>
          )}
          {contentData?.description && (
            <div className={styles.internetDescription}>
              {contentData?.description}
            </div>
          )}
        </div>
        <Button
          className={styles.button}
          href={contentData?.button_slug}
          Component={contentData?.button_slug ? 'router' : 'button'}
        >
          {contentData?.button_text} <ArrowRight width={20} />
        </Button>
      </div>
      <div className={styles.internetImage}>
        <Image
          src={contentData?.image}
          alt='Bakcell'
          title='Bakcell'
          loading='lazy'
          layout='fill'
        />
      </div>
    </div>
  </div>
);

export default InternetBlock;
